import React from 'react'
import Reveal from './Reveal'
import CountUp from './CountUp'
import { useI18n } from '../i18n/LanguageContext'

function Numbers() {
  const { t } = useI18n()

  return (
    <section className="numbers" aria-label={t.numbers.title}>
      <div className="container">
        <Reveal as="h2" className="numbers-title">{t.numbers.title}</Reveal>
        <div className="numbers-grid">
          {t.numbers.cards.map((card, index) => (
            <Reveal key={card.id} className="number-card" delay={index * 90}>
              <p className="number-role">{card.role}</p>
              <h3>{card.name}</h3>
              <p className="number-value"><CountUp to={card.value} /></p>
              <p className="number-caption">{card.caption}</p>
              <dl>
                {card.rows.map(([label, value]) => (
                  <div key={label}>
                    <dt>{label}</dt>
                    <dd>{value}</dd>
                  </div>
                ))}
              </dl>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Numbers
